import { VISITOR_ABILITIES } from './abilities/visitor';
import { TRIAL_DEMO_ABILITIES } from './abilities/trialDemo';

export * from './abilities/trialDemo';

// 缓存访客模式
let __VISITOR_MODE__ = false;
const getVisitorMode = () => {
  if (__VISITOR_MODE__) {
    return __VISITOR_MODE__;
  }
  const isVisitor = window.location.search.includes('mode=visitor');
  if (isVisitor) {
    // 缓存访客模式，页面中不重复判断
    __VISITOR_MODE__ = true;
    return true;
  }
  return false;
};

export const isVisitor = getVisitorMode();

export const ABILITIES = isVisitor ? VISITOR_ABILITIES : TRIAL_DEMO_ABILITIES;
